<div *ngIf='(vm$ | async) as vm'>
    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <div *ngIf="!vm.workingText && !vm.errorText">
        <div class="pt-2">
            <div class="row">
                <div class="col-md-12">
                    <mdb-card narrower="true" cascade="true">
                        <app-card-header title="Timesheets" [headingSize]="6"></app-card-header>
                        <mdb-card-body cascade="true">
                            <div class="row mt-n4" *ngIf="vm.payrollPeriodsVm as ppvm">
                                <div class="col-md-4">
                                    <div class="md-form form-group form-sm">
                                        <mdb-select-2 placeholder="Choose the payroll period"
                                            (selected)="getSelectedValue($event, vm.payrollPeriodsVm, vm)"
                                            [(ngModel)]="payrollPeriodId">
                                            <mdb-select-option
                                                *ngFor="let pp of vm.payrollPeriodsVm.rows; let i = index"
                                                [value]="pp.payrollPeriodId">
                                                <div class="row">
                                                    <div class="col-md-7">
                                                        {{pp.startDate | date: 'MM/dd/yyyy'}} - {{pp.endDate | date:
                                                        'MM/dd/yyyy'}}
                                                    </div>
                                                    <div class="col-md-1">
                                                        <mdb-icon *ngIf="pp.payrollPeriodLocked" fas icon="lock"
                                                            class="prefix" mdbTooltip="Period Locked">
                                                        </mdb-icon>
                                                        <mdb-icon *ngIf="!pp.payrollPeriodLocked" style="color:green;"
                                                            fas icon="lock-open" class="prefix"
                                                            mdbTooltip="Period Open"></mdb-icon>
                                                    </div>
                                                </div>
                                            </mdb-select-option>
                                        </mdb-select-2>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4" *ngIf="vm.lockedTimesheetVm as lt">
                                <div class="table-responsive">
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">Payroll Date</th>
                                                <th scope="col">Rest Breaks</th>
                                                <th scope="col">Meal Breaks</th>
                                                <th scope="col">Signed</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let c of lt"
                                                (click)="onRowClick(c.payrollPeriodDriverDayTimesheetId)"
                                                [ngStyle]="{'cursor': 'pointer', 'color': c.isSigned === false ? 'red' : null}">
                                                <td class="text-info"><u
                                                        [ngStyle]="c.isSigned === false ? { 'color': 'red' } : {}">{{c.payrollDate
                                                        | date: 'MM/dd/yyyy' }}</u></td>
                                                <td>{{c.restBreakCount }}</td>
                                                <td>{{c.mealBreakCount }}</td>
                                                <td>{{c.isSigned }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>
</div>